import { render, staticRenderFns } from "./PromoteSale.vue?vue&type=template&id=269de275"
import script from "./PromoteSale.vue?vue&type=script&lang=js"
export * from "./PromoteSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports